import type { LegacyLanguage } from '../gateway/contracts';
import {
  DEFAULT_LEGACY_SYSTEM_SETTINGS,
  parseLegacySystemSettings,
  type LegacySystemSettings,
} from './LegacySystemSettings';

export type UserSettings = Readonly<{
  configured: boolean;
  language: LegacyLanguage;
  system: LegacySystemSettings;
}>;

export const DEFAULT_USER_SETTINGS: UserSettings = Object.freeze({
  configured: false,
  language: 'english',
  system: DEFAULT_LEGACY_SYSTEM_SETTINGS,
});

export function parseUserSettings(value: unknown): UserSettings {
  if (typeof value !== 'object' || value === null) return DEFAULT_USER_SETTINGS;
  const candidate = value as Record<string, unknown>;
  return {
    configured: candidate.configured === true,
    language: legacyLanguage(candidate.language),
    system: parseLegacySystemSettings(candidate.system),
  };
}

function legacyLanguage(value: unknown): LegacyLanguage {
  switch (value) {
    case 'english':
    case 'swedish':
    case 'danish':
    case 'norwegian':
      return value;
    default:
      return 'english';
  }
}
